import { useQuery } from "@tanstack/react-query";
import type { CartDto } from "@aurelia/types";
import { apiFetch } from "../../lib/api-client";
import { useAuthStore } from "../../lib/stores/auth";

export function useCart() {
  const isAuthenticated = useAuthStore((s) => s.status === "authenticated");
  return useQuery({
    queryKey: ["cart"],
    queryFn: () => apiFetch<CartDto>("/cart"),
    enabled: isAuthenticated
  });
}

// Shipping rates are per-province/weight-tier, so the fee can't be known
// until checkout's address step has a province. Separate query (own key,
// own cache) rather than overloading useCart — the base cart badge/page
// never need a province and shouldn't refetch when one is picked.
export function useCartWithShipping(province: string | undefined) {
  const isAuthenticated = useAuthStore((s) => s.status === "authenticated");
  return useQuery({
    queryKey: ["cart", "shipping", province],
    queryFn: () => apiFetch<CartDto>(`/cart?province=${encodeURIComponent(province!)}`),
    enabled: isAuthenticated && !!province
  });
}
